import { render, staticRenderFns } from "./FilteredItemList.vue?vue&type=template&id=5940e082&"
import script from "./FilteredItemList.vue?vue&type=script&lang=js&"
export * from "./FilteredItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports